import * as React from "react";
import Component from "../../AbstractComponent";
import { AgencyFeeInterface } from "../../../Entity/Entities/AgencyFee/AgencyFeeInterface";
import AgencyFeeUpdateWillMount from "../../../Middleware/Middlewares/AgencyFeeUpdateWillMount";
import { MiddlewareInterface } from "../../../Middleware/MiddlewareInterface";
import Time from "../../../Time/Time";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import Select from "../../Partials/Material/Select";
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ReactSelect from 'react-select';
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import AssignmentServiceStatusTypeContainer from "../../../Entity/Entities/Unit/ServiceStatus/AssignmentServiceStatusTypeContainer";
import MenuItem from '@material-ui/core/MenuItem';

export class AgencyFeeUpdate extends Component {

  private agencyFee: AgencyFeeInterface;

  protected middlewares: MiddlewareInterface[] = [
    AgencyFeeUpdateWillMount
  ];

  constructor(public props) {
    super(props);

    this.agencyFee = this.props.agencyFee;
    this.onSave = this.onSave.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.updateFPPMode = this.updateFPPMode.bind(this);
  }

  public onCancel(): any {
    if (typeof this.props.onCancel !== "undefined") {
      this.props.onCancel.call(this);
    }
  }

  public onSave(): any {
    if (!this.state.firstDate && this.state.dateChoice === "firstDate") {
      return this.setState({
        firstDateError: this.trans("be_ajv_not_validated")
      });
    } else {
      this.setState({
        firstDateError: ""
      });
    }

    const payload =  {
      id: this.agencyFee.id,
      objectType: this.agencyFee.objectType,
      objectId: this.agencyFee.objectId,
      currency: this.state.currency,
      fixedFee: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.fixedFee)).replace(",", ".")).toFixed(2)),
      percentageFee: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.percentageFee)).replace(",", ".")).toFixed(2)),
      vat: parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.vat)).replace(",", ".")).toFixed(2)),
      firstDate: this.state.dateChoice === "firstDate" ? Time.formatOrNull(this.state.firstDate) : null,
      lastDate: Time.formatOrNull(this.state.lastDate),
      fixedPlusPercentageMode: this.state.fixedPlusPercentageMode && this.state.fixedPlusPercentageMode.id,
      chargeTypeIds: this.state.chargeTypeIds,
      repeatPeriodId: this.state.repeatPeriod,
      serviceStatusId: this.state.assignmentServiceStatus,
      date: Time.formatOrNull(this.state.date),
    };

    if (typeof this.props.onSave !== "undefined") {
      this.props.onSave.call(this, payload);
    }
  }

  public updateFPPMode(event) {
    const fpp = this.props.globalTypes?.FixedPlusPercentageModes?.[event.target.value];

    this.setState({
      fixedPlusPercentageMode: fpp,
      hasModifiedData: true
    });
  }

  public changeFixedFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    if (this.state.vat) {
      let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.vat)).replace(",", ".")).toFixed(2));
      vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

      let varPercentage = vatNumber / (fixedFee - vatNumber) * 100;

      return this.setState({
        vatPercentage: isFinite(varPercentage) ? this.formatter.simpleFormatNumber(Math.round(varPercentage), false, false) : "",
        fixedFee: amount,
        hasModifiedData: true
      });
    }

    if (this.state.vatPercentage) {
      let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(amount)).replace(",", ".")).toFixed(2));
      fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

      let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.vatPercentage)).replace(",", ".")).toFixed(2));
      vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

      const vatNumber = fixedFee / (100 + vatPercentageNumber) * vatPercentageNumber;

      return this.setState({
        vat: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
        fixedFee: amount,
        hasModifiedData: true
      });
    }

    return this.setState({
      vat: "",
      vatPercentage: "",
      fixedFee: amount,
      hasModifiedData: true
    });
  }

  public changeVatAmount = (event): void => {
    let vat: string = event.target.value;
    vat = this.formatter.formatSigns(vat);

    let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.fixedFee)).replace(",", ".")).toFixed(2));
    fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

    let vatNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(vat)).replace(",", ".")).toFixed(2));
    vatNumber = isNaN(vatNumber) ? 0 : vatNumber;

    const vatPercentageNumber = vatNumber / (fixedFee - vatNumber) * 100;

    this.setState({
      vat: vat,
      vatPercentage: this.formatter.simpleFormatNumber(Math.round(vatPercentageNumber), false, false),
      hasModifiedData: true
    });
  }

  public changeVatPercentageAmount = (event): void => {
    let vatPercentage: string = event.target.value;
    vatPercentage = this.formatter.formatSigns(vatPercentage);

    let fixedFee: number = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(this.state.fixedFee)).replace(",", ".")).toFixed(2));
    fixedFee = isNaN(fixedFee) ? 0 : fixedFee;

    let vatPercentageNumber: any = parseFloat(parseFloat(String(this.formatter.deleteExtraSpace(vatPercentage)).replace(",", ".")).toFixed(2));
    vatPercentageNumber = isNaN(vatPercentageNumber) ? 0 : vatPercentageNumber;

    const vatNumber = fixedFee / (100 + vatPercentageNumber) * vatPercentageNumber;

    this.setState({
      vat: this.formatter.simpleFormatNumber(Math.round(vatNumber * 100 + Number.EPSILON) / 100, false),
      vatPercentage: vatPercentage,
      hasModifiedData: true
    });
  }

  public changePercentageFeeAmount = (event): void => {
    let amount: string = event.target.value;
    amount = this.formatter.formatSigns(amount);

    this.setState({
      percentageFee: amount,
      hasModifiedData: true
    });
  }

  public selectDate = (date: Date, identifier: string): void => {
    this.setState({
      [identifier]: date,
      hasModifiedData: true
    })
  }

  public changeDateChoice = (event: any): void => {
    const choice: string = event.target.value;

    this.setState({
      dateChoice: choice,
      hasModifiedData: true
    });
  }

  public onChargeTypesSelectChange = (valArray) => {
		const types = !!valArray ? valArray.map(item => item.value) : [];

		this.setState({
      chargeTypeIds: [...types],
      hasModifiedData: true
		});
  }

  public renderChargeTypesSelect = () => {
    const chargeTypes = TypeContainer.getChargeTypesForChargeTemplates("agencyfee")
                      .filter(type => {
                        if(type.removed){
                          return false;
                        }

                        if(type.id === -1 || type.id === -2){
                          return false;
                        }

                        if(TypeContainer.pickIdFromLabel("Stub_receivable") === type.id || TypeContainer.pickIdFromLabel("Stub_payable") === type.id) {
                          return false;
                        }

                        return true;
                      })
                      .map(type => {
                        return ({
                            value: type.id,
                            label: this.formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)
                          });
                        }
                      );

    const customStyles = {
      control: (base, state) => {
        let borderColor = 'rgba(0, 0, 0, 0.23)';
        let boxShadow = 'none !important';
        let outlineColor = "auto";

        if (state.isFocused) {
          borderColor = "#00BCD4 !important";
          boxShadow = "0 0 1px 1px #00BCD4 !important";
          outlineColor = "#00BCD4 !important";

          if (!!this.getErrorFor("chargeTypeIds")) {
            borderColor = "#f44336 !important";
            boxShadow = "0 0 1px 1px #f44336 !important";
            outlineColor = "#f44336 !important";
          }
        } else {
          if (!!this.getErrorFor("chargeTypeIds")) {
            borderColor = "#f44336 !important";
            outlineColor = "#f44336 !important";
          }
        }

        return ({
          ...base,
          border: state.isFocused ? 'none !important' : "auto",
          borderColor: borderColor,
          boxShadow: boxShadow,
          outlineColor: outlineColor,
          outlineStyle: state.isFocused ? "auto !important" : "auto",
          outlineWidth: state.isFocused ? "5px !important"  : "auto",
          '&:hover': {
            borderColor: !!this.getErrorFor("chargeTypeIds") ? '#f44336' : 'black',
          }, // border style on hover
        });
      }
    }

    return (
      <div style={{position: "relative", zIndex: 2}}>
        <ReactSelect
          defaultValue={chargeTypes.filter(type => this.state.chargeTypeIds.includes(type.value))}
          isMulti
          options={chargeTypes}
          onChange={this.onChargeTypesSelectChange}
          styles={customStyles}
          placeholder={this.trans("dialog/agencyfee-field/chargetypes-label")}
          className="form-element scroll-to-charge-types"
        />
        {!!this.getErrorFor("chargeTypeIds") && <div className="component-error-text">{this.getErrorFor("chargeTypeIds")}</div>}
        <div className="hint-styles-dialog" style={{margin: "-10px 0 10px 0"}}>
          {this.trans("dialog/agencyfee-info/chargetypes")}
        </div>
      </div>
    );
  }

  public changeAssignmentServiceStatus  = (event) => {
    const type: number = event.target.value;

    this.setState({
      assignmentServiceStatus: type
    });
  }


  public render() {
    return (
      <div className="agencyfee-update-wrapper">
        <DialogContent>
          <DatePickerComponent
            {...this.props}
            id="date"
            name="date"
            className="scroll-to-date"
            label={this.trans("first-date")}
            initialDate={this.state.date}
            onChange={date => this.selectDate(date, "date")}
            clearButton={true}
            margin={"-15px 0 -5px 0"}
            width="250px"
            error={this.getErrorFor("date")}
          />

          <div
            style={{
              display: "flex"
            }}
          >
            <div style={{display: "flex", flexDirection: "column", marginRight: "20px", width: "250px"}}>
              <TextField
                autoComplete="off"
                className="form-element form-element-dialog agency-fee-dialog scroll-to-fixedFee"
                type="text"
                label={this.trans("dialog/agencyfee-field/fixedfee-label")}
                value={this.state.fixedFee}
                onChange={this.changeFixedFeeAmount}
                autoFocus={true}
                variant="standard"
                error={!!this.getErrorFor("fixedFee")}
                width="250px"
              />
              {!!this.getErrorFor("fixedFee") && <div className="component-error-text">{this.getErrorFor("fixedFee")}</div>}
            </div>

            <Select
              className="form-element form-element-dialog  agency-fee-dialog form-input scroll-to-currency correct-label-position"
              error={this.getErrorFor("currency")}
              disabled={this.props.isContractSigned}
              value={this.state.currency}
              onChange={this.sync.bind(this, this.syncronizers.CURRENCY)}
              htmlFor="currency"
              name="currency" 
              id="currency"
            >
              {this.getCurrencySelectboxes()}
            </Select>
          </div>
          <div className="hint-styles-dialog" style={{margin: "-14px 0 10px 0"}}>
            {this.trans("dialog/agencyfee-info/amount")}
          </div>

          {/* <div style={{display: "flex", alignItems: "flex-start"}}>
            <div style={{width: "50%", marginRight: "20px"}}>
              <TextField
                autoComplete="off"
                className="form-element full-size scroll-to-vat"
                type="text"
                label={this.trans("dialog/agencyfee-field/vat-label")}
                value={this.state.vat}
                onChange={this.changeVatAmount}
                variant="standard"
                error={!!this.getErrorFor("vat")}
              />
              {!!this.getErrorFor("vat") && <div className="component-error-text">{this.getErrorFor("vat")}</div>}
            </div>
            <div style={{width: "50%"}}>
              <TextField
                autoComplete="off"
                className="form-element full-size scroll-to-vatPercentage"
                type="text"
                label={this.trans("dialog/agencyfee-field/vatpercentage-label")}
                value={this.state.vatPercentage}
                onChange={this.changeVatPercentageAmount}
                variant="standard"
                error={!!this.getErrorFor("vatPercentage")}
              />
              {!!this.getErrorFor("vatPercentage") && <div className="component-error-text">{this.getErrorFor("vatPercentage")}</div>}
            </div>
          </div> */}

          <TextField
            autoComplete="off"
            className="form-element form-element-dialog agency-fee-dialog scroll-to-percentageFee"
            type="text"
            label={this.trans("dialog/agencyfee-field/percentagefee-label")}
            value={this.state.percentageFee}
            onChange={this.changePercentageFeeAmount}
            variant="standard"
            error={!!this.getErrorFor("percentageFee")}
            width="250px"
          />
          {!!this.getErrorFor("percentageFee") && <div className="component-error-text">{this.getErrorFor("percentageFee")}</div>}
          <div className="hint-styles-dialog" style={{margin: "-14px 0 10px 0"}}>
            {this.trans("dialog/agencyfee-info/percentagefee")}
          </div>

          <Select
				    className="form-element full-size form-input scroll-to-unitTypeId correct-label-position"
				    error={this.getErrorFor("assignmentServiceStatusId")}
				    value={this.state.assignmentServiceStatus}
				    onChange={this.changeAssignmentServiceStatus}
				    htmlFor="assignmentServiceStatusId"
				    label={this.trans("page/unitupdate-section/info-changeunitservicestatus/label")}
				    name="assignmentServiceStatus" 
				    id="assignmentServiceStatus"
				  >
				    <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("TenantSearch")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(2).toLowerCase()}`)}</MenuItem>
            <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("OperationalFinancial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(5).toLowerCase()}`)}</MenuItem>
            <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Financial")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(4).toLowerCase()}`)}</MenuItem>
            <MenuItem key={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} value={AssignmentServiceStatusTypeContainer.pickIdFromLabel("Operational")} className="assignment-service-status-type-el">{this.trans(`assignment_service_status_type_${AssignmentServiceStatusTypeContainer.pickLabelFromId(3).toLowerCase()}`)}</MenuItem>
				  </Select> 

          <Select
            className="form-element full-size form-input scroll-to-repeat-period correct-label-position"
            error={this.getErrorFor("repeat-period")}
            disabled={!!this.props.disabled}
            value={this.state.repeatPeriod}
            onChange={this.sync.bind(this, this.syncronizers.REPEAT_PERIOD)}
            htmlFor="repeatPeriod"
            label={this.trans("dialog/defaultchargetemplates-field/period-label")}
            name="repeatPeriod" 
            id="repeatPeriod"
          >
            {this.getRepeatPeriodAgreementSelectboxes()}
          </Select>

          {this.renderChargeTypesSelect()}

          <Select
            className="form-element form-input scroll-to-fixedPlusPercentageMode correct-label-position"
            error={this.getErrorFor("fixedPlusPercentageMode")}
            value={this.state.fixedPlusPercentageMode && this.state.fixedPlusPercentageMode.id}
            onChange={this.updateFPPMode}
            htmlFor="fixedPlusPercentageMode"
            label={this.trans("dialog/agencyfee-field/fixedpluspercentagemode-label")}
            name="fixedPlusPercentageMode" 
            id="fixedPlusPercentageMode"
            style={{width: "420px"}}
          >
            {
              Object.keys(this.props.globalTypes?.FixedPlusPercentageModes || {}).map((fpp) => {
                let fpps = this.props.globalTypes?.FixedPlusPercentageModes?.[fpp];

                return (
                  <MenuItem key={fpps.id} value={fpps.id}>{this.formatter.checkTranslationType(this.trans(fpps.label), fpps.label)}</MenuItem>
                );
              })
            }
          </Select>

          {
            this.props.showDates && (
              <div>
                { 
                  !this.props.checkAgencyFeeChargeCreated && (
                    <div>
                      <div
                        style={{
                          marginRight: "15px",
                          color: "gray",
                          width: "250px"
                        }}
                      >
                        {this.trans("dialog/agencyfee-radio/dates-hint")}
                      </div>

                      <RadioGroup
                        name="dateChoice"
                        value={this.state.dateChoice}
                        onChange={this.changeDateChoice}
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <FormControlLabel
                          value="firstDate"
                          control={<Radio color="primary" />}
                          label={
                            (<span>{this.trans("dialog/agencyfee-field/firstdate-radiobutton")}</span>)}
                        />
                        {/* <FormControlLabel
                          value="contractDate"
                          control={<Radio color="primary" />}
                          label={
                            (<span>{this.trans("dialog/agencyfee-field/startfromcontractdate-label")}</span>)}
                        /> */}
                      </RadioGroup>
                    </div>
                  )
                }

                {
                  this.state.dateChoice === "firstDate" && !this.props.checkAgencyFeeChargeCreated && (
                    <DatePickerComponent
                      {...this.props}
                      id="firstDate"
                      name="firstDate"
                      className="scroll-to-firstDate"
                      label={this.trans("dialog/agencyfee-field/firstdate-label")}
                      initialDate={this.state.firstDate}
                      onChange={date => this.selectDate(date, "firstDate")}
                      clearButton={true}
                      width="250px"
                      margin={"0 0 -10px 0"}
                      error={this.getErrorFor("firstDate") || this.state.firstDateError}
                    />
                  )
                }
        
                <div style={{display: "flex", justifyContent: "flex-start", alignItems: "baseline"}}>
                  <DatePickerComponent
                    {...this.props}
                    id="lastDate"
                    name="lastDate"
                    className="scroll-to-lastDate"
                    label={this.state.lastDate ? this.trans("label/end-date") + this.trans("field/optional") : this.trans("end-date-not-set") + this.trans("field/optional")}
                    initialDate={this.state.lastDate}
                    value={this.state.lastDate}
                    clearButton={true}
                    width="250px"
                    disabled={true}
                    error={this.getErrorFor("lastDate")}
                  />

                  {
                    this.state.lastDate && (
                      <Button
                        color="primary"
                        onClick={() => {
                          if (this.checkProcessIsBusy({
                                                        action: "end",
                                                        entityName: "agencyFee",
                                                        entity: this.agencyFee
                                                      })) {
                            this.openIsBusyPopup();
                          } else {
                            this.selectDate(null, "lastDate");
                          }
                        }}
                        style={{marginLeft: "20px", color: "#00BCD4", border: "1px solid rgba(0, 0, 0, 0.1)"}}
                        disabled={this.state.removed}
                      >
                        {this.trans("clear-end-date")}
                      </Button>
                    )
                  }

                  {
                    !this.state.lastDate && (
                      <Button
                        color="primary"
                        onClick={() => {
                          if (this.checkProcessIsBusy({
                                                        action: "end",
                                                        entityName: "agencyFee",
                                                        entity: this.agencyFee
                                                      })) {
                            this.openIsBusyPopup();
                          } else {
                            this.setState({isEndAgencyFeeDialogOpen: true})
                          }
                        }}
                        style={{marginLeft: "20px", color: "#00BCD4", border: "1px solid rgba(0, 0, 0, 0.1)"}}
                        disabled={this.state.removed}
                      >
                        {this.trans("set-end-date")}
                      </Button>
                    )
                  }
                </div>  
              </div>
            )
          }         
        </DialogContent>

        <DialogActions>
          <div className="button-container">
            <Button
              color="primary"
              onClick={this.onCancel}
            >
              {this.trans("dialog-button/cancel")}
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={this.onSave}
              disabled={this.hasModifiedData() === false}
            >
              {this.trans("dialog-button/save")}
            </Button>
          </div>
        </DialogActions>

        <PromptDialog
          {...this.props}
          title={this.trans("end-agency-fee-modal-title")}
          content={(
            <div>
              <p>{this.trans("dialog/preprocess-endagencyfee-info1")}</p>
              <div style={{width: "50%"}}>
                <DatePickerComponent
                  {...this.props}
                  label={this.state.lastDate ?
                    this.trans("end-date") : this.trans("label-click-set-the-end-date")}
                  initialDate={this.state.lastDate ? this.state.lastDate : null}
                  onChange={date => this.selectDate(date, "lastDate")}
                  clearButton={true}
                  // minDate={this.state.firstDate}
                  // minDatePlusDays={1}
                  // minDateMessage={this.trans("field/lastfinalenddate-info/error")}
                  error={this.getErrorFor("lastDate")}
                />
              </div>
            </div>
          )}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("set-end-date")}
          positiveButtonStyle={{backgroundColor:"red"}}
          openLeavePrompt={this.state.isEndAgencyFeeDialogOpen}
          onDiscard={() => {
            this.selectDate(this.agencyFee?.lastDate, "lastDate");
            this.setState({isEndAgencyFeeDialogOpen: false});
          }}
          onSave={() => this.setState({isEndAgencyFeeDialogOpen: false})}
          hideCross={true}
        />
      </div>
    );
  }
}
